module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "titlepage"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("ELIZABETH ADLER")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/9780312364496_L02.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("O"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("NE")]), _vm._v(" "), _c('em', [_vm._v("Of")]), _vm._v(" T"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("HOSE")]), _c('br'), _vm._v("M"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("ALIBU")]), _vm._v(" N"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("IGHTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/9780312364496_001.png"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11b87a1c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780312364496_epub_tp_r1.vue
// module id = 60
// module chunks = 0